<template>
  <div>
    <v-text-field 
      :label="label"
      v-mask="'##/####'"
      v-model="inputDate" 
      @click="menu = true"
      v-on:keydown="$event.preventDefault()"
      >

      <template v-slot:append>
        <v-menu v-model="menu" offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-calendar</v-icon>
          </template>
          <v-date-picker :value="calendarDate" @input="selectedDate($event)" view-mode="year"
            type="month" />
        </v-menu>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["label", "value"],
  data() {
    return {
      menu: false,
      inputDate: null,
    };
  },
  watch: {
    value(val) {
      console.log("A1", val)
      if (val) {
        console.log("A1.1", val)
        this.inputDate = moment(val).format("MM/YYYY");
      }
    },
  },
  computed: {
    calendarDate() {
      if (this.inputDate && this.inputDate.length === 7) {
        let date = moment(this.inputDate, "MM/YYYY");

        console.log("A2.1", this.inputDate)

        if (date.isValid) {
          return date.format("YYYY-MM");
        } else {
          console.log("A2.3", date)
        }
      }
      
      return null;
    },
  },
  methods: {
    async selectedDate(date) {
      if (date) {
        this.inputDate = moment(date).format("MM/YYYY");
        await this.$nextTick()
        this.inputDate = moment(date).format("MM/YYYY");
        this.menu = false;
      }
    },
  },
};
</script>